module.exports = __webpack_public_path__ + "img/product_28.16e4584.webp";